// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__FgbV6","title":"AfterFrontImage_title__O09au"};